export const MERCEDES_EVA_CLAIM_ACTION = 'eva-claim-create';
